export const environment = {
  env: 'prod',
  production: true,
  enableSentry: true,
  useHash: true,
  appId: 'b3portalbase',
  portalDomain: ''
};
